document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.blog-page.custom-blog-page .rte p').forEach(p => {
    
    const hasImage = p.querySelector('img');

    if (!hasImage && (p.innerHTML.trim() === '&nbsp;' || p.textContent.trim() === '')) {
      p.style.display = 'none';
    } else {
  
      p.style.display = 'block'; 
    }

  });
});